module.exports = __webpack_public_path__ + "static/media/Last3.e40a034b.jpg";